import { useEffect, useState } from "react";

export const LAST_APP_VERSION_KEY = "lastAppVersion";
export const STORED_CLIENT_ID_KEY = "authedCompany";
const AUTH_TOKEN_KEY = "authToken";

let GLOBAL_TOKEN: string | null = localStorage.getItem(AUTH_TOKEN_KEY);
const AUTH_TOKEN_CHANGED = new EventTarget();

const keysToPersistThroughLogOut = [LAST_APP_VERSION_KEY];

export const logOut = () => {
  setToken(null);
  const keyValuesToPersist = keysToPersistThroughLogOut.map((key) => {
    return { key, value: localStorage.getItem(key) };
  });
  localStorage.clear();
  for (const pair of keyValuesToPersist) {
    if (pair.value !== null) {
      localStorage.setItem(pair.key, pair.value);
    }
  }
};
export const setToken = (token: string | null) => {
  GLOBAL_TOKEN = token;
  if (token === null) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  } else {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
  AUTH_TOKEN_CHANGED.dispatchEvent(new Event("change"));
};

export const getToken = (): string | null => {
  return GLOBAL_TOKEN;
};

window.addEventListener("storage", (e) => {
  if (e.key === AUTH_TOKEN_KEY) {
    GLOBAL_TOKEN = e.newValue;
    AUTH_TOKEN_CHANGED.dispatchEvent(new Event("change"));
  }
});

export const useHasToken = (): boolean => {
  const [hasToken, setHasToken] = useState(!!getToken());
  useEffect(() => {
    const listener = () => setHasToken(!!getToken());
    AUTH_TOKEN_CHANGED.addEventListener("change", listener);
    return () => AUTH_TOKEN_CHANGED.removeEventListener("change", listener);
  }, []);

  return hasToken;
};
